// Halaman Haikal: 4 indikator ringkas yang bisa diklik → buka daftar yang sesuai (definisi sama dengan daftar).
import React, { useEffect, useState } from "react";
import { SourceTab } from "./marketplace_brand";
import "./press_hub.css";

export function usePressShopeeSummary() {
  const [shp, setShp] = useState(null);
  useEffect(() => {
    const h = (e) => setShp(e.detail);
    window.addEventListener("press-shopee-summary", h);
    return () => window.removeEventListener("press-shopee-summary", h);
  }, []);
  return shp;
}

const n = (v) => (typeof v === "number" ? v : 0);

function Tile({ tone, label, value, sub, active, onClick, testid }) {
  return <div role="button" tabIndex={0} className={`phub-tile ${tone}${active ? " on" : ""}`} onClick={onClick}
    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }} data-testid={testid}>
    <span>{label}</span><b>{value}</b>{sub}
  </div>;
}

export function PressSummary({ shp, offline, view, onPick }) {
  const s = shp || { siap: "…", dik: "…", late: "…" };
  const sub = (kind, sv, ov) => <small className="phub-split">
    <button type="button" onClick={(e) => { e.stopPropagation(); onPick("shopee", kind); }} data-testid={`press-sum-${kind}-shopee`}>Shopee {sv}</button>
    <button type="button" onClick={(e) => { e.stopPropagation(); onPick("offline", kind); }} data-testid={`press-sum-${kind}-offline`}>Offline {ov}</button>
  </small>;
  const pref = (kind, sv) => onPick(n(sv) > 0 || view.ch === "shopee" ? "shopee" : "offline", kind);
  return <div className="phub-sum" data-testid="press-summary">
    <Tile tone="ready" label="Siap Press Shopee" value={s.siap} active={view.ch === "shopee" && view.kind === "siap"}
      onClick={() => onPick("shopee", "siap")} testid="press-sum-shopee-ready"/>
    <Tile tone="ready" label="Offline Siap Dikerjakan" value={offline.siap} active={view.ch === "offline" && view.kind === "siap"}
      onClick={() => onPick("offline", "siap")} testid="press-sum-offline-ready"/>
    <Tile tone="work" label="Sedang Dikerjakan" value={n(s.dik) + n(offline.dik)} active={view.kind === "dik"}
      onClick={() => pref("dik", s.dik)} sub={sub("dik", s.dik, offline.dik)} testid="press-sum-working"/>
    <Tile tone={(n(s.late) + n(offline.late)) > 0 ? "late" : "neutral"} label="Terlambat" value={n(s.late) + n(offline.late)} active={view.kind === "late"}
      onClick={() => pref("late", s.late)} sub={sub("late", s.late, offline.late)} testid="press-sum-late"/>
  </div>;
}

export function PressChannelNav({ ch, setCh, shopeeCount, offlineCount }) {
  return <nav className="phub-ch mpb-tabs" role="tablist" aria-label="Kanal pekerjaan Press" data-testid="press-channel-nav">
    {[["offline", offlineCount], ["shopee", shopeeCount], ["tokopedia"]].map(([k, c]) =>
      <SourceTab key={k} channel={k} active={ch === k} onClick={() => setCh(k)} testid={`press-channel-${k}`} count={c !== "…" ? c : undefined}/>)}
  </nav>;
}

export function LateBanner({ count, onClear, testid }) {
  return <div className="phub-late" data-testid={testid}>
    Menampilkan yang <b>Terlambat</b> ({count})
    <button type="button" onClick={onClear} data-testid={`${testid}-clear`}>Tampilkan semua</button>
  </div>;
}

// Satu ringkasan = tab: SIAP · DIKERJAKAN · MENUNGGU (angka hanya di sini). Riwayat/Terlambat/Ditahan kecil.
const v = (x) => (typeof x === "number" ? x : "…");
export function PressTabs({ tab, setTab, counts, lateOn, setLateOn }) {
  const big = [["siap", "SIAP", "Boleh mulai"], ["dik", "DIKERJAKAN", "Sedang diproses"], ["wait", "MENUNGGU", "Belum bisa"]];
  return <div className="phub-tabs" data-testid="press-tabs">
    <div className="phub-big" role="tablist" aria-label="Status pekerjaan Press">
      {big.map(([k, l, s]) => <button key={k} type="button" role="tab" aria-selected={tab === k && !lateOn}
        className={`phub-bt ${k}${tab === k && !lateOn ? " on" : ""}`} onClick={() => { setLateOn(false); setTab(k); }} data-testid={`press-tab-${k}`}>
        <b>{v(counts[k])}</b><span>{l}</span><small>{s}</small></button>)}
    </div>
    <div className="phub-mini">
      {typeof counts.late === "number" && counts.late > 0 && <button type="button" className={`phub-chip late${lateOn ? " on" : ""}`}
        onClick={() => setLateOn(!lateOn)} aria-pressed={lateOn} data-testid="press-chip-late">Terlambat {counts.late}</button>}
      {typeof counts.hold === "number" && counts.hold > 0 && <button type="button" className={`phub-chip late${tab === "hold" ? " on" : ""}`}
        onClick={() => { setLateOn(false); setTab("hold"); }} data-testid="press-chip-hold">Ditahan {counts.hold}</button>}
      <button type="button" className={`phub-chip${tab === "hist" ? " on" : ""}`} onClick={() => { setLateOn(false); setTab("hist"); }}
        data-testid="press-chip-history">Riwayat</button>
    </div>
  </div>;
}
